import YatungTable, { Column } from '@Src/_basic/components/YatungTable';
import { ThirdPartyAccountTableData } from '@Src/_basic/object/ThirdPartyAccountType';
import { useApi } from '@Src/redux/api/apiAction';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import ActionColumnFormatter from './columnFormatter/ActionColumnFormatter';
import StateColumnFormatter from './columnFormatter/StateColumnFormatter';

interface Props {
  accountData: Array<ThirdPartyAccountTableData>;
}

export default function ThirdPartyAccountManagementTable(props: Props) {
  const { t: i18T } = useTranslation();
  const { actionLoading } = useApi();
  const { accountData } = props;
  const navigate = useNavigate();

  const handleGoToUpdatePage = (id: string) => {
    navigate(`/UsersManagePage/ThirdPartyAccountManagement/ThirdPartyAccountUpdate/${id}`, { state: id });
  };

  const columns: Array<Column> = [
    {
      text: i18T('GLOBAL.NO'),
      dataField: 'index',
      width: '5%',
    },
    {
      text: i18T('USERSMANAGEMENU.THIRD_PARTY_ACCOUNT_MANAGEMENT.ACCOUNT'),
      dataField: 'account',
      width: '15%',
    },
    {
      text: i18T('USERSMANAGEMENU.THIRD_PARTY_ACCOUNT_MANAGEMENT.ACCOUNT_NAME'),
      dataField: 'accountName',
      width: '12%',
    },
    {
      text: i18T('USERSMANAGEMENU.THIRD_PARTY_ACCOUNT_MANAGEMENT.DESCRIPTION'),
      dataField: 'description',
      width: '20%',
    },
    {
      text: i18T('USERSMANAGEMENU.THIRD_PARTY_ACCOUNT_MANAGEMENT.CREATE_TIME'),
      dataField: 'createDt',
      width: '13%',
    },
    {
      text: i18T('USERSMANAGEMENU.THIRD_PARTY_ACCOUNT_MANAGEMENT.UPDATE_TIME'),
      dataField: 'updateDt',
      width: '13%',
    },
    {
      text: i18T('USERSMANAGEMENU.THIRD_PARTY_ACCOUNT_MANAGEMENT.STATE'),
      dataField: 'state',
      width: '6%',
      formatter: StateColumnFormatter,
      formatExtraData: {
        enableText: i18T('USERSMANAGEMENU.THIRD_PARTY_ACCOUNT_MANAGEMENT.ENABLE'),
        disabledText: i18T('USERSMANAGEMENU.THIRD_PARTY_ACCOUNT_MANAGEMENT.DISABLED'),
      },
    },
    {
      text: i18T('USERSMANAGEMENU.THIRD_PARTY_ACCOUNT_MANAGEMENT.AVAILABLE_DAYS'),
      dataField: 'availableDays',
      width: '8%',
      formatter: ({ row }) => <>{row.extraData?.availableDays ?? ''}</>,
    },
    {
      text: i18T('GLOBAL.ACTION'),
      dataField: 'action',
      formatter: ActionColumnFormatter,
      formatExtraData: {
        onGoToUpdatePage: handleGoToUpdatePage,
        buttonText: i18T('GLOBAL.UPDATE'),
      },
    },
  ];

  return <YatungTable loading={actionLoading} columns={columns} data={accountData} />;
}
